var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9522 0.523438C25.0033 0.523438 26.011 0.943139 26.7469 1.68487L31.7253 6.66328C32.4665 7.40448 32.8829 8.40978 32.8829 9.45801C32.8829 10.5062 32.4665 11.5115 31.7253 12.2527L13.549 30.4233C12.4276 31.7169 10.838 32.5117 9.01689 32.6366H0.773438V31.0311L0.778652 24.264C0.915423 22.5711 1.70247 20.9969 2.90309 19.9391L21.1555 1.68681C21.8956 0.942192 22.9022 0.523438 23.9522 0.523438ZM8.90362 29.4301C9.7613 29.3693 10.5597 28.9702 11.2007 28.2369L23.3412 16.0965L17.3136 10.0687L5.10206 22.2773C4.4516 22.8526 4.0492 23.6574 3.98449 24.3937V29.427L8.90362 29.4301ZM19.5844 7.79847L25.6116 13.826L29.455 9.98266C29.594 9.84362 29.6721 9.65504 29.6721 9.45841C29.6721 9.26177 29.594 9.07319 29.455 8.93415L24.4721 3.95128C24.3346 3.81271 24.1475 3.73478 23.9523 3.73478C23.7571 3.73478 23.57 3.81271 23.4325 3.95128L19.5844 7.79847Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.cae4f2ea.svg";
export { ForwardRef as ReactComponent };